<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    <div>
      @if (modalData.accessMode === UserAccessMode.UPDATE_ACCESS) {
        <div>
          <div class="font-semibold text-gray-700">{{ modalData.userName }}</div>
          <div class="text-sm font-medium text-gray-500">{{ modalData.userEmail }}</div>
        </div>
      }
      @if (modalData.accessMode === UserAccessMode.ADD_ACCESS) {
        @if (isEmailRegistered() === false) {
          <div class="mb-3">
            <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
          </div>
        }
        <form [formGroup]="emailForm">
          <IFormField class="w-1/2">
            <label iLabel>{{ t("common.email") }}</label>
            <input
              iInput
              placeholder="email@example.com"
              [formControl]="emailForm.controls.email"
              size="sm"
              autoFocus
            />
            <IError>{{
              emailForm.controls.email.errors?.["email"]
                ? t("register.email_invalid_error")
                : emailForm.controls.email.errors?.["isAdmin"]
                  ? t("manage-authorized-users-modal.is_already_admin")
                  : t("manage-authorized-users-modal.is_already_authorized_user")
            }}</IError>
          </IFormField>
        </form>
      }
    </div>

    <div class="flex flex-auto flex-col gap-2">
      <span class="text-sm font-medium tracking-tight text-gray-600">
        {{ t("account-setting.manage_access") }}
      </span>

      <div class="w-1/2">
        <input
          iInput
          size="sm"
          [placeholder]="t('manage-authorized-access-modal.filter_by_account_name')"
          [ngModel]="accountNameFilter()"
          (ngModelChange)="accountNameFilter.set($event); externalFilterChanged($event)"
        />
      </div>
      <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
        <ag-grid-angular
          [rowData]="manageAccessGridData()"
          class="h-full"
          [gridOptions]="gridOptions"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
        ></ag-grid-angular>
      </div>
    </div>

    <div class="flex justify-end gap-2">
      <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button
        iButton
        (click)="save()"
        [loading]="grantOrUpdateAccessLoading()"
        [disabled]="emailForm.invalid || !hasAccessBeenUpdated()"
        [iTooltip]="!hasAccessBeenUpdated() ? t('manage-authorized-access-modal.no_changes_made') : ''"
      >
        {{ submitButtonLabel() }}
      </button>
    </div>
  </div>
</ng-container>
